function repositionBasket() {
  if ($(".id--16").length) {
    // $(".cart-content .next-step-back").text("Späť do Obchodu");
    $(".order-summary-inner").append('<div class="next-btn"></div>');
    $(".order-summary-inner .next-btn").append(
      $(".cart-content .next-step-forward")
    );
  }

  if ($(".id--15").length) {
    var thanksBanner = `
			<div class="basket-image-block">
				<img src="/user/documents/public/images/basket-final.jpg" alt="" class="img--responsive img-responsive">
			</div>
		`;

    $(".content-inner").prepend($(thanksBanner));

    $(".order-summary-heading").wrap('<div class="reca-first"></div>');
    $(".reca-first").append($(".order-summary-item.total"));
    $(".reca-first").append($(".reca-number"));
    $(".order-summary-item.summary-thx").remove();
    $(".order-complete-links")
      .closest(".recapitulation-wrapper")
      .addClass("reca-btn");

    $(".cart-table tr").each(function () {
      $(this)
        .find(".cart-p-image")
        .wrapInner('<span class="cart-p-image-inner"></span>');
    });
  }

  if ($(".id--17").length) {
    // $(".cart-content .next-step-back").text("Späť do Obchodu");
    $(".order-summary-inner").append('<div class="next-btn"></div>');
    $(".order-summary-inner .next-btn").append(
      $(".cart-content .next-step-finish")
    );
  }

  // Change Free delivery Range
  reorderBasketElements();

  $(document).on("click", ".discount-coupon .h4", function () {
    $(this).closest(".discount-coupon").toggleClass("is-active");
  });
}

function reorderBasketElements() {
  if ($(".id--9").length) {
    $(".sidebar-in-cart").append($(".summary-wrapper .next-step"));

    $(".summary-wrapper .box").append('<div class="next-btn"></div>');
    $(".summary-wrapper .next-btn").append(
      $(".sidebar-in-cart .next-step-forward")
    );

    // Add title to discount coupon
    if ($(".discount-coupon").length) {
      var discountCoupon = $(".discount-coupon");
      discountCoupon.closest(".extras-col").addClass("extras-col-basket");

      discountCoupon.prepend('<div class="h4">Mám slevový kupon</div>');

      discountCoupon.find("input").attr("placeholder", "Vložit slevový kupón");
      discountCoupon.find(".btn").text("Přidat");

      $(".js-open-discount-coupon").on("click", function () {
        $(".extras-col-basket").toggleClass("is-open");
      });
    }

    // Reposition card table items
    if ($(".cart-table").length) {
      $(".cart-table tr.removeable").each(function () {
        var cartItem = $(this);
        var cartName = cartItem.find(".p-name");
        var cartAvailability = cartItem.find(".p-availability");
        var cartQuantity = cartItem.find(".p-quantity .js-quantity-form");
        // var cartRelated = cartItem.find(".show-related");
        var cartPrice = cartItem.find(".p-price");
        var cartPriceTotal = cartItem.find(".p-total");
        var cartDiscount = cartItem.find(".p-discount");

        cartPrice.wrapInner(
          '<span class="p-price-content js-price-content"></span>'
        );
        cartDiscount.wrapInner(
          '<span class="p-discount-content js-discount-content"></span>'
        );
        // cartRelated.wrap('<td class="p-related"></td>');
        // cartAvailability.wrapInner('<span class="p-availability"></span>');

        // var cartRelatedBlock = cartItem.find(".p-related");

        // cartName.append(cartAvailability.find(".p-availability"));

        // cartName.append(cartQuantity);
        cartQuantity.insertAfter(cartName.find(".main-link"));
        cartPriceTotal.prepend(cartPrice.find(".js-price-content"));
        cartPriceTotal.prepend(cartDiscount.find(".js-discount-content"));
        // cartRelatedBlock.insertBefore(cartPriceTotal);
      });

      $(".cart-table tr.related .cart-related-product").each(function () {
        var cartItem = $(this);
        var cartName = cartItem.find(".cart-related-name");
        var cartAvail = cartItem.find(".cart-related-availability").clone();
        var cartPrice = cartItem.find(".price");

        cartName.append(cartAvail);
        cartName.append(cartPrice);
      });
    }
  }
}
